// ROSENBERG BENLİK SAYGISI HESAPLAMA MOTORU
export const calculateRosenberg = (answers) => {
  const SCORING = {
    D1: { 1: { C: 0.17, D: 0.34 }, 2: { C: 0.16, D: 0.33 }, 3: { A: 0.17, B: 0.33 }, 4: { C: 0.25, D: 0.50 }, 5: { C: 0.25, D: 0.50 }, 6: { C: 0.50, D: 1.00 }, 7: { C: 0.50, D: 1.00 }, 8: { A: 1.00, B: 0.50 }, 9: { A: 0.50, B: 0.25 }, 10: { A: 0.50, B: 0.25 } },
    D2: { 11: { A: 1, B: 1, C: 1 }, 12: { A: 1, B: 1, C: 1 }, 13: { A: 1 }, 14: { A: 1 }, 15: { B: 1 } },
    D3: { 16: { A: 1 }, 17: { B: 1 }, 18: { B: 1 }, 19: { A: 1 }, 20: { B: 1 } },
    D4: { 21: { A: 1, B: 1 }, 22: { A: 1 }, 23: { A: 1, B: 1 } },
    D5: { 24: { D: 1 }, 25: { B: 1 }, 26: { D: 1 }, 27: { B: 1 }, 28: { A: 1 }, 29: { A: 1, C: 1 } },
    D6: { 30: { A: 1 }, 31: { A: 1 }, 32: { A: 1 }, 33: { A: 1 } },
    D7: { 34: { A: 1, B: 1 }, 35: { A: 1, B: 1 }, 36: { A: 1, B: 1 }, 37: { A: 1, B: 1 }, 38: { A: 1, B: 1 }, 39: { A: 1, B: 1 }, 40: { A: 1, B: 1 }, 41: { A: 1, B: 1 }, 42: { A: 1, B: 1 }, 43: { A: 1, B: 1 } },
    D8: { 44: { A: 1 }, 45: { A: 1 }, 46: { A: 1 } },
    D9: { 47: { A: 1, B: 1 }, 48: { C: 1, D: 1 } },
    D10: { 49: { C: 1, D: 1 }, 50: { C: 1, D: 1 }, 51: { A: 1 }, 52: { A: 1 }, 53: { A: 1 }, 54: { A: 1 }, 55: { C: 1 } },
    D11: { 56: { A: 1 }, 57: { A: 1, B: 1 }, 58: { A: 1, B: 1 }, 59: { A: 1, B: 1 }, 60: { A: 1, B: 1 }, 61: { A: 1, B: 1 } },
    D12: { 62: { A: 1 }, 63: { B: 1 } }
  };

  const scores = {};
  Object.keys(SCORING).forEach(dim => {
    let total = 0;
    Object.keys(SCORING[dim]).forEach(qId => {
      const userAns = answers[qId];
      if (userAns && SCORING[dim][qId][userAns]) total += SCORING[dim][qId][userAns];
    });
    scores[dim] = dim === 'D1' ? Math.round(total) : total;
  });

  let summary = "DENGELİ (NORMAL SEVİYE)";
  let colorCode = "green";
  
  if (scores.D1 >= 5) { summary = "DÜŞÜK BENLİK SAYGISI (KIRMIZI ALARM)"; colorCode = "red"; }
  else if (scores.D1 >= 2) { summary = "ORTA DÜZEY DALGALANMA"; colorCode = "amber"; }
  
  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  let masterRisk = "low";
  if (scores.D1 >= 5) masterRisk = "high";
  else if (scores.D1 >= 2) masterRisk = "medium";

  // D1 skoru 0-6 arasıdır. Yüksek D1 = Düşük Benlik Saygısı = Yüksek Risk.
  // Evrensel sıralama için 100'lük risk puanına çeviriyoruz:
  const riskScore = Math.round((scores.D1 / 6) * 100);

  return { 
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: false, // Düşük benlik saygısı "high" risktir ancak anlık (critical) kriz değildir
    domain: "psychological", // Psikolojik alan

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
    summary, 
    analysis: "Rosenberg Benlik Saygısı başarıyla hesaplandı.", 
    risks: [], 
    chartData: [], 
    answers, 
    scores, 
    colorCode,
    riskLevel: masterRisk // Geriye dönük uyumluluk
  };
};